import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import BlockGameDevHero from "./BlockGameDevHero";
import BlockchainIntegration from "./BlockchainIntegration";
import EnhancedSecurity from "./EnhancedSecurity";

function BlockchainGameDev() {
  return (
    <div>
      <Header />
      <BlockGameDevHero />
      <BlockchainIntegration />
      <EnhancedSecurity />
      <Footer />
    </div>
  );
}

export default BlockchainGameDev;
